export default __webpack_public_path__ + "static/media/transfer.fa0bc264.svg";